export default __webpack_public_path__ + "img/brujula2.7bd0da9c.jpeg";